import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { ThemeWrapper } from 'context/theme';
import GlobalStyles from 'styles/global-styles';
import App from 'app';
import * as serviceWorker from 'serviceWorker';

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <ThemeWrapper>
    <GlobalStyles />
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>
  </ThemeWrapper>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
